<nav
  id="navtabs"
  class="md-tabs-1 md-card-tabs-1 card navbar navbar-light bg-faded"
>
  <ul class="text-center">
    <!-- User Feed-->
    <li
      class="nav-item active yourFeed"
      id="yourFeed"
      (click)="setListType($event.target)"
    >
      <a
        class="nav-link yourFeed"
        [ngClass]="{ active: type === 'AllDiscussionsFollowFeed' }"
      >
        <i
          class="icofont icofont-play-alt-3 yourFeed"
          [ngClass]="{ 'text-primary': type === 'AllDiscussionsFollowFeed' }"
        ></i>
        <span class="yourFeed">Your Feed</span>
      </a>
    </li>

    <!-- Global Feed-->
    <li
      class="nav-item globalFeed"
      id="globalFeed"
      (click)="setListType($event.target)"
    >
      <a
        class="nav-link globalFeed"
        [ngClass]="{
          active: type === 'AllDiscussionsLatestFeed' && !tag
        }"
      >
        <i
          class="icofont icofont-world globalFeed"
          [ngClass]="{
            'text-primary': type === 'AllDiscussionsLatestFeed' && !tag
          }"
        ></i>
        <span class="globalFeed">Global Feed</span>
      </a>
    </li>

    <!-- Tag Feed -->
    <li class="nav-item" [hidden]="!tag">
      <a class="nav-link active">
        <i class="icofont icofont-tags text-primary"></i>
        <span>{{ tag }}</span>
      </a>
    </li>

    <!-- Search Feed -->
    <li class="nav-item" [hidden]="!discussionSearchTerm">
      <a class="nav-link active">
        <i class="icofont icofont-search text-primary"></i>
        <span>Search results</span>
      </a>
    </li>
  </ul>
</nav>
